import type { ComponentProps } from 'react';
import { EntitySearchModal } from 'components/entity-search-modal';
import type { EntitySearchEntityType } from 'types/api-payloads';
import { useEntitySearch } from './hooks';

type EntitySearchDialogProps = Omit<
  ComponentProps<typeof EntitySearchModal>,
  'search'
> & {
  primaryEntityType?: EntitySearchEntityType;
  // The entity types the reconciliation can still accept, locked at each opening.
  allowedEntityTypes?: EntitySearchEntityType[];
};

/**
 * The entity search modal running its own search, so a search change
 * re-renders the modal rather than the page that opens it.
 * @param {EntitySearchDialogProps} props The modal, and the types to lock it to.
 * @return {JSX.Element} The modal.
 */
export function EntitySearchDialog({
  primaryEntityType,
  allowedEntityTypes,
  ...props
}: EntitySearchDialogProps) {
  const search = useEntitySearch(
    props.isOpen,
    primaryEntityType,
    allowedEntityTypes
  );
  return <EntitySearchModal {...props} search={search} />;
}
